import React from 'react';
import { StyledTable } from './TableColumnStyle';
import moment from 'moment';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';

export const requestsColumns = ({ t, lang, pageNumber, filter, type }) => {
  return [
    {
      Cell: row => (
        <Column
          data={row.original}
          index={row.index}
          t={t}
          lang={lang}
          pageNumber={pageNumber}
          filter={filter}
          type={type}
        />
      )
    }
  ];
};

const Column = ({ data, t, lang, pageNumber, filter, index, type }) => {
  return (
    <StyledTable>
      <div className="row">
        <div className="col1">
          <div>
            <b>{(pageNumber - 1) * filter.pageSize + index + 1}) </b>
            <b>{t('voucher_waitingList_DOName')}:</b>{' '}
            {lang === 'ru' ? data.serviceProviderRuName : data.serviceProviderKkName}
          </div>
          <div>
            <b>{t('voucher_waitingList_address')}:</b>{' '}
            {lang === 'ru'
              ? data.serviceProviderRuAddress
              : data.serviceProviderKkAddress}
          </div>
          <div>
            <b>{t('voucher_waitingList_childFIO')}:</b>{' '}
            {`${data?.childSurname || ''} ${data?.childName ||
              ''} ${data?.childMiddleName || ''}`}
          </div>
          <div>
            <b>{t('voucher_waitingList_childBirthday')}:</b>{' '}
            {moment(data.childBirthday).format('DD.MM.YYYY')}
          </div>
          <div>
            <b>{t('voucher_waitingList_childIIN')}:</b> {data.childIin}
          </div>
          <div>
            <b>{t('voucher_waitingList_voucherId')}:</b>{' '}
            {type === 'SC' ? data.universalVoucherId : data.kindergartenVoucherId}
          </div>
          {data.position && (
            <div>
              <b>{t('voucher_waitingList_position')}:</b> {data.position}
            </div>
          )}
        </div>
        <div className="col1">
          {data.confirmInterestDeadline && (
            <div>
              {moment(data.confirmInterestDeadline).isValid() && (
                <div>
                  <b>{t('voucher_waitingList_deadlineDateForEnroll')}:</b>{' '}
                  {moment(data.confirmInterestDeadline).format('DD.MM.YYYY')}&nbsp;&nbsp;
                  {moment(data.confirmInterestDeadline).format('HH:mm:ss')}
                </div>
              )}
            </div>
          )}
        </div>
        <div className="col2">
          <div style={{ marginBottom: '5px' }}>
            {data.appStatusWebStatus && data.appStatusWebStatus[`${lang}_name`]}
          </div>
          {data && ['RESERVED'].includes(data.status) && (
            <div>
              <Button
                style={{ marginBottom: '10px' }}
                variant="contained"
                color="secondary"
                size="small"
                className="tab_but"
                onClick={() => {
                  const filter = {
                    ...(data.universalVoucherId
                      ? { universalVoucherId: data.universalVoucherId }
                      : { kindergartenVoucherId: data.kindergartenVoucherId }),
                    status: data.status,
                    serviceProviderId: data.serviceProviderId
                  };
                  const baseUrl =
                    type === 'SC'
                      ? '/services/create/accept_universal_short'
                      : '/services/create/voucher_acceptance_ddo_short?filter=';
                  const url =
                    type === 'SC'
                      ? `${baseUrl}?filter=${encodeURIComponent(JSON.stringify(filter))}`
                      : `${baseUrl}${encodeURIComponent(JSON.stringify(filter))}`;

                  window.open(url, '_blank');
                }}
              >
                {t('voucher_waitingList_interested')}
              </Button>
            </div>
          )}
          {data.status === 'WAITING' && (
            <div style={{ paddingTop: '10px' }}>
              <Link
                to={{
                  pathname: `/kindergarten-reestr/voucherId=${
                    type === 'SC' ? data.universalVoucherId : data.kindergartenVoucherId
                  }&serviceProviderId=${data.serviceProviderId}`,
                  search: `?isChangeDuo=1${
                    type ? `&type=${type}` : ''
                  }&filter=${encodeURIComponent(
                    JSON.stringify({
                      locationCode: data.queuedRegion,
                      ageGroup: data.ageGroup
                    })
                  )}`
                }}
                style={{ textDecoration: 'none' }}
              >
                <Button variant="contained" size="small" className="tab_but">
                  {t('voucher_applications_changeDDO')}
                </Button>
              </Link>
            </div>
          )}
        </div>
      </div>
    </StyledTable>
  );
};
